<div *ngFor="let data of (relatedQcSamples | async| objectToArray)">
  <div class="Flexbox results-pane-item qc-sample" *ngFor="let sample of data.orders; index as i;">
    <span class="caption">{{"Related Control Sample:"}}</span>
    <span class="revision-name" (click)="goToControlSampleTest(data, i)">{{sample.identifiers[0].value}}</span>
    <span *ngIf="sample.resultStatus" class="control_test_tag " [ngClass]="prepareClassName(sample.resultStatus)">{{sample.resultStatus }}</span>
  </div>
</div>

<div class="Flexbox results-pane indicators-panel-padding">
  <div class="error-indicator" *ngIf="failuresInQcResults">
    <span class="icon__dls-error icon-size color_failure"></span>
    <span class="content-padding" translate>qc.fail_headline_message</span>
  </div>
  <div class="warning-indicator warning-indicator-padding indicator-padding" *ngIf="warningInQcResults">
    <span class="icon__warning_background icon-size color_warning "></span>
    <span class="content-padding" translate>qc.warn_headline_message</span>
  </div>
</div>

<div class="Flexbox FlexWrap">

  <div class="results-pane padding-top "
       *ngFor="let qcResult of qcResults | async | objectToArray|filter:f;
  let i = index;
  trackBy: trackByFn">

    <div (click)="iconToggle[i]=!iconToggle[i]"
         translate class="icon_padding_right results-pane-subheader pointer disable-select-text subheader-underline">
      <span [ngClass]="{'icon__collapse': iconToggle[i], 'icon__expand':!iconToggle[i]}"></span>
      {{'qc.'+qcResult.key}}
      <span *ngIf="qcResult.value.containsWarnings || qcResult.value.containsFailures"
            class="icon-size-normal icon-padding-left"
            [ngClass]="{
                    'icon__dls-error': !!qcResult.value.containsFailures,
                    'color_failure': !!qcResult.value.containsFailures,
                    'icon__warning_background': !qcResult.value.containsFailures && qcResult.value.containsWarnings,
                    'color_warning': !qcResult.value.containsFailures && qcResult.value.containsWarnings
        }"></span>
    </div>
    <div [ngClass]="{'sectionToggle': iconToggle[i]}" class="section-toggle-content">
      <div class="Flexbox results-pane-item" *ngFor="let qcDetailsResults of qcResult.value.metrics">
        <span
          translate
          class="results-pane-caption">
          {{'qc.'+qcDetailsResults.metric.toLowerCase()}}
        </span>
        <span
          translate
          class="results-pane-value"
          [ngClass]="{
            'color_failure': qcDetailsResults.withinFailRange,
            'color_warning': !qcDetailsResults.withinFailRange && qcDetailsResults.withinWarningRange
          }"
        >
          {{qcDetailsResults.value}}
        </span>
        <span
          *ngIf="qcDetailsResults.withinFailRange || qcDetailsResults.withinWarningRange"
          class="icon-size-normal icon-padding-left"
          [ngClass]="{
          'icon__dls-error': qcDetailsResults.withinFailRange,
          'color_failure': qcDetailsResults.withinFailRange,
          'icon__warning_background': !qcDetailsResults.withinFailRange && qcDetailsResults.withinWarningRange,
          'color_warning': !qcDetailsResults.withinFailRange && qcDetailsResults.withinWarningRange
          }">
        </span>
      </div>
    </div>

  </div>

</div>
